import { Button, type ButtonProps } from 'antd';
import React from 'react';
import { useAppTheme } from '@/theme';

type MyButtonProps = Omit<
  ButtonProps,
  'type' | 'variant' | 'className' | 'style' | 'color'
> & {
  // 统一的按钮风格，使用主题预设（对齐 theme.components.buttons 的所有键）
  variant?: keyof ReturnType<
    typeof import('@/theme/presets').createComponentPresets
  >['buttons'];
  // 可选圆角，默认无圆角
  rounded?: number | string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
};

const MyButton = ({
  variant = 'primary',
  rounded,
  children,
  style,
  className,
  ...props
}: MyButtonProps) => {
  const theme = useAppTheme();

  // Get button preset based on variant
  const buttonPreset = theme.components.buttons[variant]();

  return (
    <Button
      {...props}
      {...buttonPreset}
      className={`my-button ${className ?? ''}`.trim()}
      style={{
        ...buttonPreset.style,
        ...(rounded !== undefined ? { borderRadius: rounded as any } : {}),
        ...style,
      }}
    >
      {children}
    </Button>
  );
};

export default MyButton;
